import { captureException } from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { ErrorView } from './error.view';

export const RouterErrorView = () => {
  const error = useRouteError();

  useEffect(() => {
    captureException(error);
  }, [error]);

  return <ErrorView />;
};
